<template>
  <div class="container">
    <a-form :model="handleList" class="search-form" @submit="handleList">
      <a-form-item>
        <div class="form-item-content">
          <a-button type="primary" @click="handleAdd">添加商品</a-button>
        </div>
      </a-form-item>
      <a-form-item name="status">
        <div class="form-item-content">
          <div class="label">商品分类：</div>
          <a-select
            style="width: 200px"
            v-model:value="listRequest.category_id"
          >
            <a-select-option
              v-for="category in categoryList"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <a-form-item name="content">
        <div class="form-item-content">
          <div class="label">搜索内容：</div>
          <a-input
            placeholder="商品描述/商品详细"
            v-model:value="listRequest.content"
          />
        </div>
      </a-form-item>
      <a-form-item name="create_at">
        <div class="form-item-content">
          <div class="label">创建时间：</div>
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="createAtChange"
          />
        </div>
      </a-form-item>
      <a-form-item name="update_at">
        <div class="form-item-content">
          <div class="label">修改时间：</div>
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="updateAtChange"
          />
        </div>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">搜索</a-button>
        <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>
      </a-form-item>
    </a-form>
  </div>
  <div class="container">
    <a-table
      :columns="columns"
      :data-source="productList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'status'">
          <a-tag v-if="record.status === 1" color="green">可用</a-tag>
          <a-tag v-if="record.status === 2" color="red">禁用</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'image_url'">
          <a-image
            v-for="i in record.image_url.slice(0, 2)"
            :key="i"
            :src="ToImage(i)"
            style="height: 60px; width: auto"
          />
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'update_at'">
          <span
            >{{ dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openAdd"
      title="添加商品数据"
      @ok="submitAdd"
      cancelText="取消"
      width="1000px"
    >
      <a-form :model="addRequest">
        <a-form-item label="商品名称">
          <a-input v-model:value="addRequest.name" />
        </a-form-item>
        <a-form-item label="商品描述">
          <a-input v-model:value="addRequest.description" />
        </a-form-item>
        <a-form-item label="商品详情">
          <a-input v-model:value="addRequest.content" />
        </a-form-item>
        <a-form-item label="商品价格">
          <a-input-number v-model:value="addRequest.price" />
        </a-form-item>
        <a-form-item label="商品打折前的价格">
          <a-input-number v-model:value="addRequest.before_price" />
        </a-form-item>
        <a-form-item label="商品规格">
          <a-input v-model:value="addRequest.specification" />
        </a-form-item>
        <a-form-item label="商品运费">
          <a-input-number v-model:value="addRequest.fright" />
        </a-form-item>
        <a-form-item label="商品库存">
          <a-input-number v-model:value="addRequest.stock" />
        </a-form-item>
        <a-form-item label="已售数量">
          <a-input-number v-model:value="addRequest.sold_count" />
        </a-form-item>
        <a-form-item label="出售状态">
          <a-select v-model:value="addRequest.status">
            <a-select-option :value="1">待审核</a-select-option>
            <a-select-option :value="2">出售中</a-select-option>
            <a-select-option :value="3">仓库中</a-select-option>
            <a-select-option :value="4">下架</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="addRequest.category_id">
            <a-select-option
              v-for="category in categoryList"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="图片">
          <Files-Upload v-model="addRequest.image_url" style="display: block" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:open="openUpdate"
      title="修改会员数据"
      @ok="submitUpdate"
      cancelText="取消"
      width="1000px"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="商品名称">
          <a-input v-model:value="updateRequest.name" />
        </a-form-item>
        <a-form-item label="商品描述">
          <a-input v-model:value="updateRequest.description" />
        </a-form-item>
        <a-form-item label="商品详情">
          <a-input v-model:value="updateRequest.content" />
        </a-form-item>
        <a-form-item label="商品价格">
          <a-input-number v-model:value="updateRequest.price" />
        </a-form-item>
        <a-form-item label="商品打折前的价格">
          <a-input-number v-model:value="updateRequest.before_price" />
        </a-form-item>
        <a-form-item label="商品规格">
          <a-input v-model:value="updateRequest.specification" />
        </a-form-item>
        <a-form-item label="商品运费">
          <a-input-number v-model:value="updateRequest.fright" />
        </a-form-item>
        <a-form-item label="商品库存">
          <a-input-number v-model:value="updateRequest.stock" />
        </a-form-item>
        <a-form-item label="已售数量">
          <a-input-number v-model:value="updateRequest.sold_count" />
        </a-form-item>
        <a-form-item label="出售状态">
          <a-select v-model:value="updateRequest.status">
            <a-select-option :value="1">待审核</a-select-option>
            <a-select-option :value="2">出售中</a-select-option>
            <a-select-option :value="3">仓库中</a-select-option>
            <a-select-option :value="4">下架</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="updateRequest.category_id">
            <a-select-option
              v-for="category in categoryList"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="图片">
          <Files-Upload
            v-model="updateRequest.image_url"
            style="display: block"
          />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { ProductService } from "@/api/services/ProductService";
import { ToImage } from "@/utils/image";
import { Product } from "@/api/models/product/Product";
import { ProductListRequest } from "@/api/models/product/ProductListRequest";
import { ProductUpdateRequest } from "@/api/models/product/ProductUpdateRequest";
import { ProductAddRequest } from "@/api/models/product/ProductAddRequest";
import { Moment } from "moment/moment";
import { Category } from "@/api/models/catrgory/Category";
import { CategoryService } from "@/api/services/CategoryService";
import FilesUpload from "@/components/FilesUpload.vue";

dayjs.locale("zh-cn");

const total = ref<number>(0);

const listRequest = reactive<ProductListRequest>({
  current: 1,
  size: 20,
  content: "",
  status: 3,
});

const createAtChange = (_: Moment, mode: string) => {
  listRequest.start_time = Date.parse(mode);
};

const updateAtChange = (_: Moment, mode: string) => {
  listRequest.end_time = Date.parse(mode);
};

const productList = ref<Product[]>([]);

const handleList = async () => {
  const res = await ProductService.ListAll(listRequest);
  if (res.code === 0) {
    productList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.category_id = 0;
  listRequest.start_time = 0;
  listRequest.end_time = 0;
  handleList();
};

const categoryList = ref<Category[]>([]);

const handleCategory = async () => {
  const res = await CategoryService.ListAll({
    current: 1,
    size: 1000000,
    content: "",
  });
  if (res.code === 0) {
    categoryList.value = res.data.records;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
  await handleCategory();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<ProductAddRequest>({
  name: "",
  description: "",
  content: "",
  price: 0,
  before_price: 0,
  fright: 0,
  image_url: [],
  status: 1,
  stock: 0,
  sold_count: 0,
  specification: "",
});

const handleAdd = () => {
  openAdd.value = true;
};

const submitAdd = async () => {
  const res = await ProductService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<ProductUpdateRequest>({
  id: 0,
  name: "",
  is_delete: 0,
  description: "",
  content: "",
  price: 0,
  before_price: 0,
  fright: 0,
  image_url: [],
  category_id: 0,
  status: 0,
  sold_count: 0,
  specification: "",
});

const handleUpdate = (record: Product) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await ProductService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Product) => {
  const res = await ProductService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Product) => {
  const res = await ProductService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "商品名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "描述",
    dataIndex: "description",
    align: "center",
  },
  {
    title: "详细内容",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "价格",
    dataIndex: "price",
    align: "center",
  },
  {
    title: "打折前的价格",
    dataIndex: "before_price",
    align: "center",
  },
  {
    title: "类别",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "运费",
    dataIndex: "fright",
    align: "center",
  },
  {
    title: "图片",
    dataIndex: "image_url",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
